import React from 'react';
import './LocationList.css';
// import FontAwesomeIcon from '@fortawesome/react-fontawesome';
// import faMap from '@fortawesome/fontawesome-free-solid/faMap';
// import faPhone from '@fortawesome/fontawesome-free-solid/faPhone';
// import faMarker from '@fortawesome/fontawesome-free-solid/faMapMarkerAlt';
import LocationItem from '../components/LocationItem';

const LocationList = props => (
  <div className="location-list">
    {
      props.locations.map((elem, idx) => {
        return <LocationItem key={`location-item-${idx}`} data={elem}/>
      })
    }
  </div>
)
  
export default LocationList;



// WEBPACK FOOTER //
// ./src/containers/LocationList.js